import { UseFormReturnCustomized } from 'hooks/form'
import { FieldValues, FormProvider } from 'react-hook-form'

interface IFormProps<TFieldValues extends FieldValues, TContext extends object, TAdditionalData extends object> {
  form: UseFormReturnCustomized<TFieldValues, TContext, TAdditionalData>
  onSubmit?: () => void | Promise<void>
  children: React.ReactNode
}

/**
 * This component is a wrapper to provide the form context to the children
 * and also wraps them in an html form element for submitting by pressing enter.
 * Finally is allows customizing the onSubmit handler.
 */
function Form<
  TFieldValues extends FieldValues,
  TContext extends object,
  TAdditionalData extends object
>({ form, onSubmit, children }: IFormProps<TFieldValues, TContext, TAdditionalData>) {
  return (
    <FormProvider {...form}>
      <form onSubmit={onSubmit || form.submit}>
        {children}
      </form>
    </FormProvider>
  )
}

export default Form
